const SUPPORTED_WEB_LOCALES = ["en", "el", "de"];

export const getLocaleFromPathname = (pathname, fallback = "en") => {
  const firstSegment = String(pathname || "")
    .split("/")
    .filter(Boolean)[0]
    ?.toLowerCase();

  if (firstSegment && SUPPORTED_WEB_LOCALES.includes(firstSegment)) {
    return firstSegment;
  }

  return fallback;
};
